<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Convênios</div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form action>
                    <div class="form-row">
                      <div class="form-group col-md-8">
                        <label for="Name">
                          <span class="required">*</span> Título:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          id="Name"
                          class="form-control"
                          v-model="entity.title"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-2">
                        <label for="Name">
                          <span class="required">*</span> Código:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          id="Name"
                          class="form-control"
                          v-model="entity.code"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-2">
                        <label for="Ans">
                          <span class="required">*</span> ANS:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          id="Ans"
                          class="form-control"
                          v-model="entity.ans"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-4">
                        <label for="Central">
                          <span class="required">*</span> Central:
                        </label>
                        <select
                          id="Central"
                          class="form-control"
                          v-model="entity.central_id"
                        >
                          <option :value="null">Selecione uma central</option>
                          <option
                            v-for="central in centrals"
                            :key="central.id"
                            :value="central.id"
                          >
                            {{ central.fantasy_name }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header">Planos</div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 text-right mb-2">
                  <button
                    class="btn btn-primary"
                    data-toggle="modal"
                    data-target="#newPlan"
                  >
                    Adicionar
                  </button>
                </div>
                <div class="col-md-12">
                  <table class="table">
                    <tr>
                      <th scope="col" style="width: 45%">Código</th>
                      <th scope="col" style="width: 45%">Nome</th>
                      <th scope="col" style="width: 10%">Ações</th>
                    </tr>
                    <tr v-for="(plan, index) in entity.plans" :key="index">
                      <td style="width: 45%">{{ plan ? plan.code : "" }}</td>
                      <td style="width: 45%">{{ plan ? plan.title : "" }}</td>
                      <td style="width: 10%">
                        <button
                          class="btn btn-crud delete"
                          @click="removePlan(index)"
                        >
                          <i class="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                    <tr v-if="entity.plans.length == 0">
                      <td colspan="3" align="center">Nenhum cadastrado</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header">Vínculos</div>
            <div class="card-body">
              <div class="row" v-if="entity.id">
                <div class="col-md-12 text-right mb-2">
                  <button
                    class="btn btn-primary"
                    data-toggle="modal"
                    data-target="#newLink"
                  >
                    Adicionar
                  </button>
                </div>
                <div class="col-md-12">
                  <table class="table">
                    <tr>
                      <th scope="col" style="width: 30%">Tipo</th>
                      <th scope="col" style="width: 30%">Motivo</th>
                      <th scope="col" style="width: 30%">Plano</th>
                      <th scope="col" style="width: 10%">Ações</th>
                    </tr>
                    <tr v-for="(link, index) in entity.links" :key="index">
                      <td style="width: 30%">
                        {{ link.type ? link.type.title : "" }}
                      </td>
                      <td style="width: 30%">
                        {{ link.reason ? link.reason.title : "" }}
                      </td>
                      <td style="width: 30%">
                        {{ link.plan ? link.plan.title : "" }}
                      </td>
                      <td style="width: 10%">
                        <button
                          class="btn btn-crud delete"
                          @click="removeLink(index)"
                        >
                          <i class="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                    <tr v-if="entity.links.length == 0">
                      <td colspan="4" align="center">Nenhum cadastrado</td>
                    </tr>
                  </table>
                </div>
              </div>
              <div class="row" v-else>
                <div class="col-md-12">
                  <div class="alert alert-danger" role="alert">
                    Para realizar os vínculos, você precisa primeiro adicionar
                    este convênio, em seguida realizar uma edição.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="block text-right">
                    <router-link
                      to="/medical-agreements"
                      class="btn btn-back mr-1"
                    >
                      <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                    <a class="btn btn-add" @click="save">
                      Salvar
                      <i class="fa fa-save"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Plano -->
    <div
      class="modal fade"
      id="newPlan"
      tabindex="-1"
      role="dialog"
      aria-labelledby="newPlanTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Novo Plano</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                <label>Código</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="new_plan.code"
                />
              </div>
              <div class="col-md-6">
                <label>Nome</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="new_plan.title"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Fechar
            </button>
            <button type="button" class="btn btn-primary" @click="addPlan">
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Vinculos -->
    <div
      class="modal fade"
      id="newLink"
      tabindex="-1"
      role="dialog"
      aria-labelledby="newLinkTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Novo Vínculo</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-4">
                <label>Tipo</label>
                <v-select
                  v-model="new_link.type_id"
                  class="vselect"
                  :options="types"
                  :reduce="(types) => types.id"
                  :label="'title'"
                  @input="getReasons"
                />
              </div>
              <div class="col-md-4">
                <label>Motivo</label>
                <v-select
                  v-model="new_link.reason_id"
                  class="vselect"
                  :options="reasons"
                  :reduce="(reasons) => reasons.id"
                  :label="'title'"
                />
              </div>
              <div class="col-md-4">
                <label>Plano</label>
                <v-select
                  v-model="new_link.plan_id"
                  class="vselect"
                  :options="entity.plans"
                  :reduce="(plans) => plans.id"
                  :label="'title'"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Fechar
            </button>
            <button type="button" class="btn btn-primary" @click="addLink">
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  data() {
    return {
      new_plan: {
        code: null,
        title: null,
      },
      new_link: {
        type_id: null,
        reason_id: null,
        plan_id: null,
      },
      centrals: [],
      entity: {
        title: null,
        code: null,
        ans: null,
        central_id: null,
        plans: [],
        links: [],
      },
      types: [],
      reasons: [],
    };
  },
  computed: {},
  mounted() {
    this.getCentrals();
  },
  methods: {
    getCentrals() {
      const self = this;
      const api = self.$store.state.api + "centrals?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.centrals = response.data.data.sort((a, b) =>
            a.fantasy_name.localeCompare(b.fantasy_name)
          );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    removePlan(index) {
      const self = this;

      if (!self.entity.id) {
        self.entity.plans.splice(index, 1);
      } else {
        let api =
          self.$store.state.api +
          "medical-agreement-plans/" +
          self.entity.plans[index].id;

        axios
          .delete(api)
          .then((response) => {
            self.$message("Sucesso", `Plano removido com sucesso`, "success");

            self.getEntity(self.entity.id);
          })
          .catch((error) => {
            self.$message(null, error.response.data, "error");
          });
      }
    },
    addPlan() {
      const self = this;

      if (!self.new_plan.code || !self.new_plan.title) {
        self.$message("Ops!", `Você precisa preencher todos os dados`, "error");
        return;
      }

      if (!self.entity.id) {
        self.entity.plans.push(self.new_plan);
      } else {
        let api = self.$store.state.api + "medical-agreement-plans";

        self.new_plan.medical_agreement_id = self.entity.id;

        axios
          .post(api, self.new_plan)
          .then((response) => {
            self.$message("Sucesso", `Plano incluído com sucesso`, "success");

            self.getEntity(self.entity.id);
          })
          .catch((error) => {
            self.$message(null, error.response.data, "error");
          });
      }

      self.new_plan = {
        code: null,
        title: null,
      };

      $("#newPlan").modal("hide");
    },
    removeLink(index) {
      const self = this;

      if (!self.entity.id) {
        self.entity.links.splice(index, 1);
      } else {
        let api =
          self.$store.state.api +
          "medical-agreement-links/" +
          self.entity.links[index].id;

        axios
          .delete(api)
          .then((response) => {
            self.$message("Sucesso", `Plano removido com sucesso`, "success");

            self.getEntity(self.entity.id);
          })
          .catch((error) => {
            self.$message(null, error.response.data, "error");
          });
      }
    },
    addLink() {
      const self = this;

      if (
        !self.new_link.type_id ||
        !self.new_link.reason_id ||
        !self.new_link.plan_id
      ) {
        self.$message("Ops!", `Você precisa preencher todos os dados`, "error");
        return;
      }

      if (!self.entity.id) {
        self.entity.links.push(self.new_link);
      } else {
        let api = self.$store.state.api + "medical-agreement-links";

        self.new_link.medical_agreement_id = self.entity.id;

        axios
          .post(api, self.new_link)
          .then((response) => {
            self.$message("Sucesso", `Plano incluído com sucesso`, "success");

            self.getEntity(self.entity.id);
          })
          .catch((error) => {
            self.$message(null, error.response.data, "error");
          });
      }

      self.new_link = {
        code: null,
        title: null,
      };

      $("#newLink").modal("hide");
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "medical-agreements";

      if (self.entity.id) {
        self.entity._method = "PUT";
        api += "/" + self.entity.id;
      }

      axios
        .post(api, self.entity)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/medical-agreements");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getEntity: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "medical-agreements/" +
        id +
        "?with[]=plans&with[]=links&with[]=central";

      axios
        .get(api)
        .then((response) => {
          self.entity = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getTypes: function (id) {
      const self = this;
      const api = self.$store.state.api + "types?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.types = response.data.data.sort((a, b) =>
            a.title.localeCompare(b.title)
          );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getReasons: function () {
      const self = this;
      const api =
        self.$store.state.api +
        "reasons?paginated=false&type_id=" +
        self.new_link.type_id;

      axios
        .get(api)
        .then((response) => {
          self.reasons = response.data.data.sort((a, b) =>
            a.title.localeCompare(b.title)
          );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    let id = self.$route.params.id;

    if (id) {
      self.getEntity(id);
    }

    self.getTypes();
    self.getCentrals();
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>
